import { generate } from '@issuu/iutk';
const KEY = 'iutk';
const ANONYMOUS_IUTK = '00000000-0000-0000-0000-000000000000';
let iutk = null;
function getIutkCookie() {
    if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
        const cookies = document.cookie.split(';').filter(item => item.includes(`${KEY}=`));
        if (cookies.length) {
            return cookies[0].split('=')[1].trim();
        }
    }
    return null;
}
function setIutkCookie() {
    function getDomain() {
        if (typeof document !== 'undefined') {
            const m = /(?:t?)issuu.com$/.exec(document.domain || '');
            return !!m ? m[0] : null;
        }
        return null;
    }
    const iutk = generate();
    const domain = getDomain();
    const maxAge = 60 * 60 * 24 * 30 * 6;
    document.cookie = `${KEY}=${iutk}${domain ? `;domain=${domain}` : ''};path=/;max-age=${maxAge};samesite=none;secure`;
}
export function determineIutk() {
    if (iutk === null) {
        let iutkCookie;
        try {
            iutkCookie = getIutkCookie();
            if (iutkCookie === null) {
                setIutkCookie();
                iutkCookie = getIutkCookie();
            }
        }
        catch {
            iutkCookie = null;
        }
        if (iutkCookie === null) {
            iutk = ANONYMOUS_IUTK;
        }
        else {
            iutk = iutkCookie;
        }
    }
    return iutk;
}
//# sourceMappingURL=iutk.js.map